<script>
import MultipleRadios from '@wielink-application/shared/vue/components/form/input-only/multiple-radios.vue'

export default MultipleRadios;
</script>